import { computed } from 'vue'
import store from '../store'

const modules = computed(() => store.getters['tenantModule/modules'])

export function useHasModule() {
    function hasModule(slug = null) {
        if (!slug) {
            return true
        }
        if (Array.isArray(slug)) {
            if (slug.length === 0) {
                return true
            }
            for (let s of slug) {
                if (modules.value.indexOf(s) !== -1) {
                    return true
                }
            }
            return false
        }
        return modules.value.indexOf(slug) !== -1
    }

    return { hasModule }
}
